import { render, staticRenderFns } from "./myDonateDetail.vue?vue&type=template&id=ed39c846&scoped=true"
import script from "./myDonateDetail.vue?vue&type=script&lang=js"
export * from "./myDonateDetail.vue?vue&type=script&lang=js"
import style0 from "./myDonateDetail.vue?vue&type=style&index=0&id=ed39c846&prod&lang=less&scoped=true"
import style1 from "./myDonateDetail.vue?vue&type=style&index=1&id=ed39c846&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed39c846",
  null
  
)

export default component.exports